export function CaixasHistorySkeleton() {
  return (
    <div
      className="caixas-history-skeleton"
      data-testid="caixas-history-skeleton"
      aria-label="Carregando histórico de caixas"
    >
      <div className="caixas-skeleton-toolbar">
        <span className="caixas-skeleton-line" />
        <span className="caixas-skeleton-line" />
      </div>
      {Array.from({ length: 5 }, (_, row) => (
        <div className="caixas-skeleton-row" key={row}>
          {Array.from({ length: 6 }, (_, column) => (
            <span className="caixas-skeleton-line" key={column} />
          ))}
        </div>
      ))}
    </div>
  );
}
